import React, { Component } from 'react';
import Styles from '../sass/layout/Cta.module.sass'

function Cta() {

  
  return(
    <div className={Styles.cta}>
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-8">
            <div className={Styles.cta__wrapper}>
              <p>Let's talk</p>
              <h2 className={Styles.cta__title}>About your next project</h2>
            </div>
          </div>
          <div className="col-lg-4">
            <a href="mailto:fahaddevs@gmail.com" data-text="fahaddevs@gmail.com" className={Styles.cta__btn}>
              <span>Get In Touch</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Cta